import {
    Dashboard,
    LocalShipping,
  } from "@mui/icons-material";
  
  export const driverMenu = [
    {
      title: "Dashboard",
      icon: <Dashboard />,
      path: "/admin",
      items: [],
    },
    {
      title: "Surat Jalan",
      icon: <LocalShipping />,
      path: "/admin/surat-jalan",
      items: [],
    },
   
  ];
  